const FILTER_SOURCES = [
  ['manager_user_id', 'agents'],
  ['responsible_user_id', 'agents'],
  ['post_sale_status', 'postSaleStatuses'],
  ['draft_status', 'static'],
  ['payment_method', 'static'],
  ['receipt_type', 'static'],
  ['review_section', 'static'],
];

const valuesOf = value => (Array.isArray(value) ? value : []);

const catalogLabel = (catalog, value, labelKey) =>
  catalog.find(item => String(item.id) === String(value))?.[labelKey];

const staticLabel = (key, value, t) => {
  switch (`${key}:${value}`) {
    case 'draft_status:fazendo':
      return t('SALES.FILTERS.DOING');
    case 'draft_status:pronto':
      return t('SALES.FILTERS.READY');
    case 'payment_method:1':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.CASH');
    case 'payment_method:2':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.FINANCING');
    case 'payment_method:3':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.FGTS');
    case 'payment_method:4':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.CONSORTIUM');
    case 'payment_method:5':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.INSTALLMENTS');
    case 'payment_method:6':
      return t('SALES.FILTERS.PAYMENT_OPTIONS.PIX');
    case 'receipt_type:manual':
      return t('SALES.FILTERS.RECEIPT_OPTIONS.MANUAL');
    case 'receipt_type:docusign':
      return t('SALES.FILTERS.RECEIPT_OPTIONS.DOCUSIGN');
    case 'review_section:imovel':
      return t('SALES.FILTERS.REVIEW_OPTIONS.PROPERTY');
    case 'review_section:vendedor':
      return t('SALES.FILTERS.REVIEW_OPTIONS.SELLER');
    case 'review_section:comprador':
      return t('SALES.FILTERS.REVIEW_OPTIONS.BUYER');
    case 'review_section:recibo':
      return t('SALES.FILTERS.REVIEW_OPTIONS.RECEIPT');
    default:
      return null;
  }
};

const labelFor = ({ source, key, value, catalogs, t }) => {
  if (source === 'static') return staticLabel(key, value, t);
  return catalogLabel(
    catalogs[source] || [],
    value,
    source === 'agents' ? 'name' : 'label'
  );
};

export const getSalesActiveFilterEntries = ({
  filters,
  agents = [],
  postSaleStatuses = [],
  t,
}) => {
  const catalogs = { agents, postSaleStatuses };

  return FILTER_SOURCES.flatMap(([key, source]) =>
    valuesOf(filters?.[key]).flatMap(value => {
      const label = labelFor({ source, key, value, catalogs, t });
      return label ? [{ key, value, label }] : [];
    })
  );
};
